import {createAction} from "@reduxjs/toolkit";
import * as types from "../constants/ActionTypes";

export const fetchDealerPlanningConfiguration = createAction(types.FETCH_DEALER_PLANNING_CONFIGURATION);
export const fetchDealerPlanningConfigurationSuccess = createAction(types.FETCH_DEALER_PLANNING_CONFIGURATION_SUCCESS);
export const fetchDealerPlanningConfigurationFailure = createAction(types.FETCH_DEALER_PLANNING_CONFIGURATION_FAILURE, (error) => ({error}));

export const saveDealerPlanningConfiguration = createAction(types.SAVE_DEALER_PLANNING_CONFIGURATION);
export const saveDealerPlanningConfigurationSuccess = createAction(types.SAVE_DEALER_PLANNING_CONFIGURATION_SUCCESS);
export const saveDealerPlanningConfigurationFailure = createAction(types.SAVE_DEALER_PLANNING_CONFIGURATION_FAILURE, (error) => ({error}));
